@if (folderFormId || folderFormData) {
    <div class="gaps-between-sections">
        <div class="grid-2col input-grid-gaps">
            <div class="fr-2 font-bold">{{ 'form.evaluation' | translate }}</div>
            @for (key of keys.slice(0, 3); track key) {
                <app-select-input
                    [id]="key"
                    [form]="form"
                    [staticOptions]="options.slice(1)"
                    [label]="'form.ni.fields.' + key"
                    valueKey="value"
                    [autoDisplayFirst]="false">
                    <ng-template #item let-data>
                        {{ ('form.ni.' + key + 'Options.' + data.name) | translate }}
                    </ng-template>
                    <ng-template #selectedItem let-data>
                        {{ ('form.ni.' + key + 'Options.' + data.name) | translate }}
                    </ng-template>
                </app-select-input>
            }

            <app-select-input
                id="contact"
                [form]="form"
                [staticOptions]="options"
                label="form.ni.fields.contact"
                valueKey="value"
                [autoDisplayFirst]="false">
                <ng-template #item let-data>
                    {{ ('form.ni.contactOptions.' + data.name) | translate }}
                </ng-template>
                <ng-template #selectedItem let-data>
                    {{ ('form.ni.contactOptions.' + data.name) | translate }}
                </ng-template>
            </app-select-input>

            @for (key of keys.slice(4, 6); track key) {
                <app-select-input
                    [id]="key"
                    [form]="form"
                    [staticOptions]="options.slice(1)"
                    [label]="'form.ni.fields.' + key"
                    valueKey="value"
                    [autoDisplayFirst]="false">
                    <ng-template #item let-data>
                        {{ ('form.ni.' + key + 'Options.' + data.name) | translate }}
                    </ng-template>
                    <ng-template #selectedItem let-data>
                        {{ ('form.ni.' + key + 'Options.' + data.name) | translate }}
                    </ng-template>
                </app-select-input>
            }

            <app-select-input
                id="consciousness"
                [form]="form"
                [staticOptions]="options"
                label="form.ni.fields.consciousness"
                valueKey="value"
                [autoDisplayFirst]="false">
                <ng-template #item let-data>
                    {{ ('form.ni.consciousnessOptions.' + data.name) | translate }}
                </ng-template>
                <ng-template #selectedItem let-data>
                    {{ ('form.ni.consciousnessOptions.' + data.name) | translate }}
                </ng-template>
            </app-select-input>

            <app-select-input
                id="problemSolving"
                [form]="form"
                [staticOptions]="options.slice(2)"
                label="form.ni.fields.problemSolving"
                valueKey="value"
                [autoDisplayFirst]="false">
                <ng-template #item let-data>
                    {{ ('form.ni.problemSolvingOptions.' + data.name) | translate }}
                </ng-template>
                <ng-template #selectedItem let-data>
                    {{ ('form.ni.problemSolvingOptions.' + data.name) | translate }}
                </ng-template>
            </app-select-input>

            <app-select-input
                id="orientation"
                [form]="form"
                [staticOptions]="options.slice(0, 3)"
                label="form.ni.fields.orientation"
                valueKey="value"
                [autoDisplayFirst]="false">
                <ng-template #item let-data>
                    {{ ('form.ni.orientationOptions.' + data.name) | translate }}
                </ng-template>
                <ng-template #selectedItem let-data>
                    {{ ('form.ni.orientationOptions.' + data.name) | translate }}
                </ng-template>
            </app-select-input>

            <app-select-input
                id="perception"
                [form]="form"
                [staticOptions]="options.slice(2)"
                label="form.ni.fields.perception"
                valueKey="value"
                [autoDisplayFirst]="false">
                <ng-template #item let-data>
                    {{ ('form.ni.perceptionOptions.' + data.name) | translate }}
                </ng-template>
                <ng-template #selectedItem let-data>
                    {{ ('form.ni.perceptionOptions.' + data.name) | translate }}
                </ng-template>
            </app-select-input>
        </div>

        <div class="grid-2col_auto input-grid-gaps">
            <div class="fr-2 font-bold">{{ 'form.finalEvaluation' | translate }}</div>
            <app-text-area-input
                id="note"
                [form]="form"
                label="form.ni.fields.note"
                class="fr-2"
            ></app-text-area-input>

            <div>{{ 'form.ni.dependency' | translate }}:</div>
            <div class="font-bold">{{ finalEvaluation }}</div>

            <div>{{ 'form.totalPoints' | translate }}:</div>
            <div class="font-bold">{{ totalPoints }}</div>
        </div>

        <div class="grid-4col input-grid-gaps">
            <div class="fr-4 font-bold">{{ 'form.administration' | translate }}</div>
            <app-select-input
                [form]="form"
                id="user"
                [infiniteScroll]="store.userScroll()"
                valueKey="id"
                label="form.ni.fields.user"
            >
                <ng-template #item let-item>
                    {{ item | formatPerson }}
                </ng-template>
                <ng-template #selectedItem let-item>
                    {{ item | formatPerson }}
                </ng-template>
            </app-select-input>
            <app-date-input
                id="date"
                [form]="form"
                label="form.ni.fields.date"
            ></app-date-input>
        </div>

        <app-action-buttons
            [primaryButtonVisibility]="form.enabled"
            (primaryClickEvent)="submit()"
            (secondaryClickEvent)="closeForm.emit()"
        ></app-action-buttons>
    </div>
}
